module.exports = __webpack_public_path__ + "img/bd.282dcf12.svg";